// extracted by mini-css-extract-plugin
export var container = "unity-video-section-module--container--5HMh9";
export var video = "unity-video-section-module--video--SEncH";
export var muteButton = "unity-video-section-module--mute-button--MYC03";
export var unmuteButton = "unity-video-section-module--unmute-button--kV+JO";
export var hidden = "unity-video-section-module--hidden--31Hc5";
export var icon = "unity-video-section-module--icon--I8F+b";